<div [ngClass]="{'cursor-none': !capability?.displayName && !capability?.name}" class="w-100-percent div-height">
  <div [ngClass]="{'disabled': !capability?.displayName && !capability?.name}" class="flex flex-col p-6  w-100-percent div-height">
    <div >
      <button class="flex justify-center btn-bgcolor fs-16 fw-400 ">{{capability?.displayName ? (capability?.displayName) : ((capability?.name) ? (capability?.name) : 'INSTANCE_SUMMARY.SERVICE_DEFINITION.NOT_AVAILABLE' | transloco) }}</button>
    </div>
  </div>
</div>
